import { InjectableClass } from '@fino/lib-injection';

export class ControllerService extends InjectableClass {
  constructor(
    $log,
    $translate,
    $locale,
    tmhDynamicLocale,
    $state,
    $stateParams,
    $timeout,
    $window,
    appCache,
    appConfig,
    envService,
    errorService,
    trackingService,
  ) {
    'ngInject';
    super({
      $log,
      $translate,
      $locale,
      tmhDynamicLocale,
      $state,
      $stateParams,
      $timeout,
      $window,
      appCache,
      appConfig,
      envService,
      errorService,
      trackingService,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/base/controller.service.js